const locale = {
    placeholder: "Selezionare l'orario",
    rangePlaceholder: ['Inizio orario', 'Fine orario'],
};
export default locale;
